var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error"},[_vm._v("\n    错误\n    "),_c('button',{on:{"click":function($event){return _vm.btn()}}},[_vm._v("返回")]),_vm._v(" "),_c('a',{attrs:{"href":"javascript:history.back(-1)"}},[_vm._v("返回")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11cd5997","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/error/404.vue
// module id = null
// module chunks = 